export default {
    props: {
        categoryAxisCategoryAxisItemAxisCrossingValue: {
            type: [Object, Date, Array],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.axisCrossingValue'
        }, 
        categoryAxisCategoryAxisItemCategories: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.categories'
        }, 
        categoryAxisCategoryAxisItemColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.color'
        }, 
        categoryAxisCategoryAxisItemField: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.field'
        }, 
        categoryAxisCategoryAxisItemJustified: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.justified'
        }, 
        categoryAxisCategoryAxisItemLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.background'
        }, 
        categoryAxisCategoryAxisItemLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.border.color'
        }, 
        categoryAxisCategoryAxisItemLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.border.dashType'
        }, 
        categoryAxisCategoryAxisItemLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.border.width'
        }, 
        categoryAxisCategoryAxisItemLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.color'
        }, 
        categoryAxisCategoryAxisItemLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.font'
        }, 
        categoryAxisCategoryAxisItemLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.format'
        }, 
        categoryAxisCategoryAxisItemLabelsMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.margin'
        }, 
        categoryAxisCategoryAxisItemLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.mirror'
        }, 
        categoryAxisCategoryAxisItemLabelsPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.padding'
        }, 
        categoryAxisCategoryAxisItemLabelsRotation: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.rotation'
        }, 
        categoryAxisCategoryAxisItemLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.skip'
        }, 
        categoryAxisCategoryAxisItemLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.step'
        }, 
        categoryAxisCategoryAxisItemLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.template'
        }, 
        categoryAxisCategoryAxisItemLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.visible'
        }, 
        categoryAxisCategoryAxisItemLabelsCulture: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.culture'
        }, 
        categoryAxisCategoryAxisItemLabelsDateFormats: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.labels.dateFormats'
        }, 
        categoryAxisCategoryAxisItemLineColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.line.color'
        }, 
        categoryAxisCategoryAxisItemLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.line.dashType'
        }, 
        categoryAxisCategoryAxisItemLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.line.visible'
        }, 
        categoryAxisCategoryAxisItemLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.line.width'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.color'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.dashType'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.visible'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.width'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.step'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.skip'
        }, 
        categoryAxisCategoryAxisItemMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.size'
        }, 
        categoryAxisCategoryAxisItemMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.visible'
        }, 
        categoryAxisCategoryAxisItemMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.color'
        }, 
        categoryAxisCategoryAxisItemMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.width'
        }, 
        categoryAxisCategoryAxisItemMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.step'
        }, 
        categoryAxisCategoryAxisItemMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.skip'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.color'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.dashType'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.visible'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.width'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.step'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.skip'
        }, 
        categoryAxisCategoryAxisItemMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.size'
        }, 
        categoryAxisCategoryAxisItemMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.visible'
        }, 
        categoryAxisCategoryAxisItemMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.color'
        }, 
        categoryAxisCategoryAxisItemMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.width'
        }, 
        categoryAxisCategoryAxisItemMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.step'
        }, 
        categoryAxisCategoryAxisItemMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.skip'
        }, 
        categoryAxisCategoryAxisItemName: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.name'
        }, 
        categoryAxisCategoryAxisItemPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.plotBands'
        },         categoryAxisCategoryAxisItemReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.reverse'
        }, 
        categoryAxisCategoryAxisItemTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.background'
        }, 
        categoryAxisCategoryAxisItemTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.border.color'
        }, 
        categoryAxisCategoryAxisItemTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.border.dashType'
        }, 
        categoryAxisCategoryAxisItemTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.border.width'
        }, 
        categoryAxisCategoryAxisItemTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.color'
        }, 
        categoryAxisCategoryAxisItemTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.font'
        }, 
        categoryAxisCategoryAxisItemTitleMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.margin'
        }, 
        categoryAxisCategoryAxisItemTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.position'
        }, 
        categoryAxisCategoryAxisItemTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.rotation'
        }, 
        categoryAxisCategoryAxisItemTitleText: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.text'
        }, 
        categoryAxisCategoryAxisItemTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.title.visible'
        }, 
        categoryAxisCategoryAxisItemType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.type'
        }, 
        categoryAxisCategoryAxisItemAutoBaseUnitSteps: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.autoBaseUnitSteps'
        }, 
        categoryAxisCategoryAxisItemBaseUnit: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.baseUnit'
        }, 
        categoryAxisCategoryAxisItemBaseUnitStep: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.baseUnitStep'
        }, 
        categoryAxisCategoryAxisItemMax: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.max'
        }, 
        categoryAxisCategoryAxisItemMin: {
            type: Object,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.min'
        }, 
        categoryAxisCategoryAxisItemRoundToBaseUnit: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.roundToBaseUnit'
        }, 
        categoryAxisCategoryAxisItemWeekStartDay: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.weekStartDay'
        }, 
        categoryAxisCategoryAxisItemMaxDateGroups: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.maxDateGroups'
        }, 
        categoryAxisCategoryAxisItemVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.visible'
        }, 
        categoryAxisCategoryAxisItemCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.color'
        }, 
        categoryAxisCategoryAxisItemCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.width'
        }, 
        categoryAxisCategoryAxisItemCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.opacity'
        }, 
        categoryAxisCategoryAxisItemCrosshairDashType: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.dashType'
        }, 
        categoryAxisCategoryAxisItemCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.visible'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.background'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.border.color'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.border.width'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.color'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.font'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.format'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.padding'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.template'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.visible'
        }, 
        categoryAxisCategoryAxisItemNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.position'
        }, 
        categoryAxisCategoryAxisItemNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.background'
        }, 
        categoryAxisCategoryAxisItemNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.border.color'
        }, 
        categoryAxisCategoryAxisItemNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.border.width'
        }, 
        categoryAxisCategoryAxisItemNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.size'
        }, 
        categoryAxisCategoryAxisItemNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.type'
        }, 
        categoryAxisCategoryAxisItemNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.visible'
        }, 
        categoryAxisCategoryAxisItemNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.background'
        }, 
        categoryAxisCategoryAxisItemNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.border.color'
        }, 
        categoryAxisCategoryAxisItemNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.border.dashType'
        }, 
        categoryAxisCategoryAxisItemNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.border.width'
        }, 
        categoryAxisCategoryAxisItemNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.color'
        }, 
        categoryAxisCategoryAxisItemNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.font'
        }, 
        categoryAxisCategoryAxisItemNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.template'
        }, 
        categoryAxisCategoryAxisItemNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.visible'
        }, 
        categoryAxisCategoryAxisItemNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.rotation'
        }, 
        categoryAxisCategoryAxisItemNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.format'
        }, 
        categoryAxisCategoryAxisItemNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.position'
        }, 
        categoryAxisCategoryAxisItemNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.line.width'
        }, 
        categoryAxisCategoryAxisItemNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.line.color'
        }, 
        categoryAxisCategoryAxisItemNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.line.length'
        }, 
        categoryAxisCategoryAxisItemNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'categoryAxis.categoryAxisItem.notes.data'
        }    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/CategoryAxis.js